import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@shigo-ui/ui';

/** A field label with an info tooltip. */
export function PlacementFieldLabel(props: { label: string; tooltip: string }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      {props.label}
      <TooltipProvider delayDuration={150}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              className="text-muted-foreground hover:text-foreground inline-flex"
              aria-label={`${props.label} info`}
            >
              <Info className="h-3.5 w-3.5" aria-hidden="true" />
            </span>
          </TooltipTrigger>
          <TooltipContent className="max-w-xs">{props.tooltip}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </span>
  );
}
